import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AvisClientsCarousel from '../components/AvisClientsCarousel';
import VehicleCard from '../components/VehicleCard';
import { getVehiclesPublic } from '../services/api';
import { useScrollRestore } from '../hooks/useScrollRestore';

function Promotions() {
  const [vehicles, setVehicles] = useState([]);
  const [vendus, setVendus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtreReduction, setFiltreReduction] = useState(null);
  const [search, setSearch] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [showTri, setShowTri] = useState(false);
  const [tri, setTri] = useState('reduction-desc');
  const [filters, setFilters] = useState({
    carburant: '', transmission: '', marque: '', modele: '', anneeMin: '', moisMin: '', anneeMax: '', moisMax: '', prixMin: '', prixMax: '',
  });

  useEffect(() => {
    getVehiclesPublic()
      .then(res => {
        const promos = res.data.filter(v => v.prixPromo && v.prixPromo < v.prix && v.statut === 'EN_LIGNE');
        setVehicles(promos);
        setVendus(res.data.filter(v => v.statut === 'VENDU' && v.prixPromo && v.prixPromo < v.prix).slice(0, 6));
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  useScrollRestore(loading);

  const getReduction = (v) => Math.round(((v.prix - v.prixPromo) / v.prix) * 100);

  const marques = [...new Set(vehicles.map(v => v.marque).filter(Boolean))].sort();
  const modeles = [...new Set(vehicles.filter(v => !filters.marque || v.marque === filters.marque).map(v => v.modele).filter(Boolean))].sort();
  const reductions = [...new Set(vehicles.map(v => getReduction(v)))].sort((a, b) => a - b);

  const [page, setPage] = useState(1);
  const PAGE_SIZE = 30;
  const handleFilterChange = (e) => { setFilters({ ...filters, [e.target.name]: e.target.value }); setPage(1); };

  const resetFilters = () => {
    setFilters({ carburant: '', transmission: '', marque: '', modele: '', anneeMin: '', moisMin: '', anneeMax: '', moisMax: '', prixMin: '', prixMax: '' });
    setSearch('');
    setFiltreReduction(null);
    setTri('reduction-desc');
  };

  const vehiclesFiltres = vehicles.filter(v => {
    const s = search.toLowerCase();
    const matchSearch = !search ||
      (v.marque && v.marque.toLowerCase().includes(s)) ||
      (v.modele && v.modele.toLowerCase().includes(s)) ||
      (v.carburant && v.carburant.toLowerCase().includes(s));
    const matchReduction = !filtreReduction || getReduction(v) >= filtreReduction;
    const matchCarburant = !filters.carburant || v.carburant === filters.carburant;
    const matchTransmission = !filters.transmission || v.transmission === filters.transmission;
    const matchMarque = !filters.marque || v.marque === filters.marque;
    const matchModele = !filters.modele || v.modele === filters.modele;
    const dateMatch = v.dateMiseEnCirculation ? String(v.dateMiseEnCirculation).match(/(\d{2})\/(\d{2})\/(\d{4})/) : null;
    const dateValeur = dateMatch ? parseInt(dateMatch[3]) * 100 + parseInt(dateMatch[2]) : null;
    const dateMin = filters.anneeMin ? parseInt(filters.anneeMin) * 100 + (filters.moisMin ? parseInt(filters.moisMin) : 1) : null;
    const dateMax = filters.anneeMax ? parseInt(filters.anneeMax) * 100 + (filters.moisMax ? parseInt(filters.moisMax) : 12) : null;
    const matchAnneeMin = !dateMin || (dateValeur !== null && dateValeur >= dateMin);
    const matchAnneeMax = !dateMax || (dateValeur !== null && dateValeur <= dateMax);
    const matchPrixMin = !filters.prixMin || v.prixPromo >= parseInt(filters.prixMin);
    const matchPrixMax = !filters.prixMax || v.prixPromo <= parseInt(filters.prixMax);
    return matchSearch && matchReduction && matchCarburant && matchTransmission && matchMarque && matchModele && matchAnneeMin && matchAnneeMax && matchPrixMin && matchPrixMax;
  });

  return (
    <div className="bg-white min-h-screen">
      <Header />

      <div className="max-w-7xl mx-auto px-4 py-16">

        <div className="text-center mb-12">
          <h1 className="text-5xl font-extrabold text-black mb-4">
            Nos <span className="text-yellow-500">promotions</span>
          </h1>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-gray-500 text-lg">Les meilleures offres du moment</p>
        </div>

        {!loading && vehicles.length > 0 && (
          <>
            <div className="flex gap-3 mb-4">
              <div className="flex-1 relative">
                <input
                  type="text"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  placeholder="Rechercher par marque, modèle, carburant..."
                  className="w-full border-2 border-gray-200 rounded-xl px-5 py-3 focus:outline-none focus:border-yellow-500 transition text-black"
                />
                {search && (
                  <button onClick={() => setSearch('')} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-black">x</button>
                )}
              </div>
              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`px-6 py-3 rounded-xl font-bold border-2 transition ${showFilters ? 'bg-yellow-500 text-black border-yellow-500' : 'border-gray-200 text-gray-600 hover:border-yellow-500 hover:text-yellow-600'}`}
              >
                Filtres
              </button>
              <div className="relative">
                <button onClick={() => setShowTri(!showTri)} className={`px-6 py-3 rounded-xl font-bold border-2 transition flex items-center gap-2 ${showTri ? 'bg-yellow-500 text-black border-yellow-500' : 'border-gray-200 text-gray-600 hover:border-yellow-500 hover:text-yellow-600'}`}>
                  Trier <span className="text-xs">{showTri ? '▲' : '▼'}</span>
                </button>
                {showTri && (
                  <>
                    <div className="fixed inset-0 z-10" onClick={() => setShowTri(false)} />
                    <div className="absolute right-0 top-full mt-2 bg-white border border-gray-200 rounded-2xl shadow-xl z-20 min-w-48 overflow-hidden">
                      {[
                        { value: 'reduction-desc', label: 'Réduction max' },
                        { value: 'prix-asc', label: 'Prix croissant' },
                        { value: 'prix-desc', label: 'Prix décroissant' },
                        { value: 'nouveautes', label: 'Nouveautés' },
                      ].map(opt => (
                        <button key={opt.value} onClick={() => { setTri(opt.value); setShowTri(false); }}
                          className={`w-full text-left px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition border-b border-gray-100 last:border-0 ${tri === opt.value ? 'font-bold text-black' : 'text-gray-600'}`}>
                          {opt.label}
                          {tri === opt.value && <span className="text-yellow-500 text-lg">✓</span>}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>

        <div className="flex items-center gap-3 mb-6">
          <label className="text-gray-600 font-semibold text-sm whitespace-nowrap">Réduction minimum :</label>
          <select
            value={filtreReduction || ''}
            onChange={e => setFiltreReduction(e.target.value ? parseInt(e.target.value) : null)}
            className="border-2 border-gray-200 rounded-xl px-4 py-2 focus:outline-none focus:border-red-500 transition text-black font-semibold"
          >
            <option value="">Toutes les offres</option>
            {reductions.map(r => (
              <option key={r} value={r}>Jusqu'à -{r}%</option>
            ))}
          </select>
        </div>

            {showFilters && (
              <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 mb-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="text-gray-600 text-sm font-semibold mb-1 block">Marque</label>
                    <select name="marque" value={filters.marque} onChange={handleFilterChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black">
                      <option value="">Toutes</option>
                      {marques.map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm font-semibold mb-1 block">Modèle</label>
                    <select name="modele" value={filters.modele} onChange={handleFilterChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black">
                      <option value="">Tous</option>
                      {modeles.map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm font-semibold mb-1 block">Carburant</label>
                    <select name="carburant" value={filters.carburant} onChange={handleFilterChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black">
                      <option value="">Tous</option>
                      <option value="Essence">Essence</option>
                      <option value="Diesel">Diesel</option>
                      <option value="Electrique">Electrique</option>
                      <option value="Hybride">Hybride</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm font-semibold mb-1 block">Transmission</label>
                    <select name="transmission" value={filters.transmission} onChange={handleFilterChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black">
                      <option value="">Toutes</option>
                      <option value="Manuelle">Manuelle</option>
                      <option value="Automatique">Automatique</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm font-semibold mb-1 block">Mise en circ. depuis</label>
                    <div className="flex gap-2">
                      <select name="moisMin" value={filters.moisMin} onChange={handleFilterChange} className="flex-1 border border-gray-200 rounded-lg px-2 py-2 focus:outline-none focus:border-yellow-500 text-black text-sm">
                        <option value="">Mois</option>
                        {['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'].map((m,i) => <option key={i+1} value={String(i+1).padStart(2,'0')}>{m}</option>)}
                      </select>
                      <input type="number" name="anneeMin" value={filters.anneeMin} onChange={handleFilterChange} placeholder="Année" min="1990" max="2030" className="w-24 border border-gray-200 rounded-lg px-2 py-2 focus:outline-none focus:border-yellow-500 text-black text-sm" />
                    </div>
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm font-semibold mb-1 block">Mise en circ. jusqu'à</label>
                    <div className="flex gap-2">
                      <select name="moisMax" value={filters.moisMax} onChange={handleFilterChange} className="flex-1 border border-gray-200 rounded-lg px-2 py-2 focus:outline-none focus:border-yellow-500 text-black text-sm">
                        <option value="">Mois</option>
                        {['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'].map((m,i) => <option key={i+1} value={String(i+1).padStart(2,'0')}>{m}</option>)}
                      </select>
                      <input type="number" name="anneeMax" value={filters.anneeMax} onChange={handleFilterChange} placeholder="Année" min="1990" max="2030" className="w-24 border border-gray-200 rounded-lg px-2 py-2 focus:outline-none focus:border-yellow-500 text-black text-sm" />
                    </div>
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm font-semibold mb-1 block">Prix promo min (€)</label>
                    <input type="number" name="prixMin" value={filters.prixMin} onChange={handleFilterChange} placeholder="Ex: 5000" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black" />
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm font-semibold mb-1 block">Prix promo max (€)</label>
                    <input type="number" name="prixMax" value={filters.prixMax} onChange={handleFilterChange} placeholder="Ex: 30000" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 text-black" />
                  </div>
                </div>
                <div className="flex justify-between items-center mt-4">
                  <p className="text-gray-500 text-sm">{vehiclesFiltres.length} offre(s) trouvée(s)</p>
                  <button onClick={resetFilters} className="text-red-400 hover:text-red-600 font-semibold text-sm transition">Réinitialiser</button>
                </div>
              </div>
            )}
          </>
        )}

        {loading ? (
          <div className="text-center text-yellow-500 text-xl py-20">Chargement...</div>
        ) : vehicles.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-6xl mb-4">🏷️</p>
            <p className="text-2xl text-gray-500 mb-2">Aucune promotion en cours</p>
            <p className="text-gray-400">Revenez bientôt pour découvrir nos offres</p>
          </div>
        ) : vehiclesFiltres.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-2xl text-gray-500 mb-2">Aucun véhicule avec ces critères</p>
            <button onClick={resetFilters} className="text-yellow-500 font-bold hover:underline mt-2">
              Réinitialiser les filtres
            </button>
          </div>
        ) : (() => {
          const sortedPromos = [...vehiclesFiltres].sort((a, b) => {
            if (tri === 'reduction-desc') return getReduction(b) - getReduction(a);
            if (tri === 'prix-asc') return (a.prixPromo || a.prix || 0) - (b.prixPromo || b.prix || 0);
            if (tri === 'prix-desc') return (b.prixPromo || b.prix || 0) - (a.prixPromo || a.prix || 0);
            if (tri === 'nouveautes') return b.id - a.id;
            return (a.position ?? 9999) - (b.position ?? 9999);
          });
          const totalPages = Math.ceil(sortedPromos.length / PAGE_SIZE) || 1;
          const paginated = sortedPromos.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
          const getPageNums = (cur, tot) => {
            if (tot <= 7) return Array.from({ length: tot }, (_, i) => i + 1);
            const p = [1];
            if (cur > 4) p.push('...');
            for (let i = Math.max(2, cur - 1); i <= Math.min(tot - 1, cur + 1); i++) p.push(i);
            if (cur < tot - 3) p.push('...');
            p.push(tot);
            return p;
          };
          const goToPage = (p) => { setPage(p); document.getElementById('vehicules-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
          return (
            <>
              <div id="vehicules-section" />
              <p className="text-gray-500 mb-8">{sortedPromos.length} offre(s) en promotion</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {paginated.map(vehicle => (
                  <div key={vehicle.id} id={`vehicle-${vehicle.id}`}>
                    <VehicleCard vehicle={vehicle} />
                  </div>
                ))}
              </div>
              {totalPages > 1 && (
                <div className="flex items-center justify-center gap-2 mt-12 flex-wrap">
                  <button onClick={() => goToPage(page - 1)} disabled={page === 1} className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 disabled:opacity-30 hover:border-yellow-500 hover:text-yellow-600 transition font-bold">‹</button>
                  {getPageNums(page, totalPages).map((p, i) =>
                    p === '...' ? <span key={`e-${i}`} className="w-10 h-10 flex items-center justify-center text-gray-400 text-sm">…</span>
                    : <button key={p} onClick={() => goToPage(p)} className={`w-10 h-10 rounded-full border text-sm font-bold transition ${p === page ? 'bg-yellow-500 border-yellow-500 text-black' : 'border-gray-200 text-gray-600 hover:border-yellow-500 hover:text-yellow-600'}`}>{p}</button>
                  )}
                  <button onClick={() => goToPage(page + 1)} disabled={page === totalPages} className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 disabled:opacity-30 hover:border-yellow-500 hover:text-yellow-600 transition font-bold">›</button>
                </div>
              )}
            </>
          );
        })()}
      </div>

      {vendus.length > 0 && (
        <div className="bg-gray-50 border-t border-gray-100 py-16 px-4 mt-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-8">
              <div>
                <p className="text-yellow-500 text-sm font-bold uppercase tracking-widest mb-1">Déjà partis</p>
                <h2 className="text-black font-extrabold text-3xl">Promotions <span className="text-yellow-500">vendues</span></h2>
              </div>
              <a href="/vendus" className="text-gray-500 hover:text-yellow-500 font-semibold text-sm transition flex items-center gap-1">Voir tous les vendus <span className="text-lg">→</span></a>
            </div>
            <div className="flex gap-5 overflow-x-auto pb-4" style={{ scrollbarWidth: 'thin', scrollbarColor: '#eab308 #f3f4f6' }}>
              {vendus.map(v => (
                <a key={v.id} href={`/vehicle/${v.id}`} className="flex-shrink-0 w-64 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group block" style={{ height: '200px' }}>
                  <div className="relative h-full overflow-hidden">
                    {v.mainImageUrl ? <img src={v.mainImageUrl} alt={`${v.marque} ${v.modele}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <div className="w-full h-full bg-gray-800 flex items-center justify-center text-5xl">🚗</div>}
                    <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                      <span className="bg-yellow-500 text-black text-sm font-extrabold px-4 py-2 rounded-xl transform -rotate-12 shadow-lg">VENDU</span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                      <h4 className="font-bold text-white text-sm leading-tight">{v.marque} {v.modele}</h4>
                      <p className="text-gray-300 text-xs mt-1">{v.dateMiseEnCirculation}{v.kilometrage ? ` · ${v.kilometrage.toLocaleString()} km` : ''}</p>
                      <p className="text-gray-300 text-xs mt-0.5">{v.carburant}</p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
      <AvisClientsCarousel />
      <Footer />
    </div>
  );
}

export default Promotions;